import { Col, Row, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiShowForm } from "../../actions/ui";
import { ProductoScreen } from "./ProductoScreen";
import { ProductosTable } from "./ProductosTable";
import { ButtonUi } from "../ui/ButtonUi";
import { TipoButtonConstants } from "../../types/typesConstants";
import { productoStartLoading } from "../../actions/producto";
import { PageHeaderUi } from "../ui/PageHeaderUi";
import { ProductoSearchFormTable } from "./ProductoSearchFormTable";
import { ImportarDatosModal } from "./modal/ImportarDatosModal";
import { UploadOutlined } from "@ant-design/icons";
const ProductosListScreen = () => {
  const dispatch = useDispatch();
  const { productos, paginator, loadingOp } = useSelector(
    (state) => state.producto
  );
  const [openModal, setOpenModal] = useState(false);

  const handleNuevo = () => {
    dispatch(uiShowForm(true));
  };
  const handleLoad = () => {
    localStorage.removeItem("SearhFormTable");
    dispatch(productoStartLoading({}));
  };
  const handleOpenImportarModal = () => setOpenModal(true);
  const handleCloseImportarModal = () => setOpenModal(false);
  return (
    <>
      <PageHeaderUi
        title="Items"
        subTitle="Listado"
        extra={[
          <Space key="options" wrap>
            <ButtonUi
              key="importar"
              typeUi={TipoButtonConstants.CustomButton}
              onClick={handleOpenImportarModal}
              icon={<UploadOutlined />}
              text="Importar"
            />
            <ButtonUi
              key="actualizar"
              typeUi={TipoButtonConstants.Actualizar}
              onClick={handleLoad}
            />
            <ButtonUi
              key="nuevo"
              typeUi={TipoButtonConstants.Nuevo}
              onClick={handleNuevo}
            />
          </Space>,
        ]}
      >
        <div style={{ overflow: "hidden" }}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={24}>
              <ProductoSearchFormTable />
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={24}>
              <ProductosTable
                productos={productos}
                loading={loadingOp}
                paginator={paginator}
              />
            </Col>
          </Row>
          <ImportarDatosModal
            open={openModal}
            handleClose={handleCloseImportarModal}
          />
        </div>
      </PageHeaderUi>
    </>
  );
};
export const ProductosList = () => {
  const dispatch = useDispatch();
  const { visibleForm } = useSelector((state) => state.ui);
  useEffect(() => {
    dispatch(productoStartLoading({}));
  }, [dispatch]);
  if (visibleForm) {
    return <ProductoScreen />;
  } else {
    return <ProductosListScreen />;
  }
};
export default ProductosList;
